import GrayLine from 'components/shared/GrayLine';
import React, { ReactNode, useEffect, useState } from 'react';
import { CheckboxInput, Grid, IconType, IDropdownAnchor, ISelectOption, TextInput } from 'ui-toolkit';
import { ClickToViewTableHeader } from './ClickToViewTableHeader';

export interface ICheckboxListProps {
  text: string;
  allIsEmpty?: boolean;
  options: ISelectOption<string>[];
  values?: string[];
  onFilterChange: (x: string[]) => void;
  sortItem?: ReactNode;
  anchor?: IDropdownAnchor;
}

export const CheckboxList: React.FC<ICheckboxListProps> = ({
  options,
  onFilterChange,
  values,
  text,
  sortItem,
  anchor,
}) => {
  const [filterText, setFilterText] = useState<string>('');
  const [selected, setSelected] = useState<string[]>(values ?? options.map((t) => t.value));

  useEffect(() => {
    setSelected(values ?? options.map((t) => t.value));
  }, [values, setSelected, options]);

  const onCheckboxChange = (value: string) => (checked: boolean) => {
    if (checked) {
      setSelected([...selected.filter((t) => t !== value), value]);
    } else {
      const newSelected = [...selected.filter((t) => t !== value)];
      setSelected(newSelected);
    }
  };
  const onAllChange = (value: boolean) => {
    value ? setSelected(options.map((t) => t.value)) : setSelected([]);
  };

  return (
    <ClickToViewTableHeader
      anchor={anchor}
      text={text}
      filterText={values && !!values.length && `(${values.length})`}
      filterComponent={
        <Grid>
          <TextInput
            value={filterText}
            onChange={(value) => setFilterText(value ?? '')}
            prependIconType={IconType.Search}
            placeholder={'Search'}
          />
          <Grid>
            <CheckboxInput
              onChange={onAllChange}
              text={'All'}
              value={selected.length >= options.length}
              data-test-id={'all'}
            />
            <GrayLine />
            {options
              .filter((t) => t.label.toLocaleLowerCase().includes((filterText ?? '').toLocaleLowerCase()))
              .map((item) => (
                <CheckboxInput
                  key={item.value}
                  onChange={onCheckboxChange(item.value)}
                  text={item.label}
                  name={item.value}
                  value={selected.includes(item.value)}
                  data-test-id={item.value}
                />
              ))}
          </Grid>
        </Grid>
      }
      onFilterDone={() => onFilterChange(selected.length === options.length ? [] : selected)}
      sortItem={sortItem}
    />
  );
};
